import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

import themeColorsDesingSystem from "assets/theme/ds-colors";

const STEPS = [
  { key: 0, label: "Informações" },
  { key: 1, label: "Configuração" },
  { key: 2, label: "Produtos" },
  { key: 3, label: "Público Alvo" },
];

function StepCircle({
  index,
  label,
  active,
  completed,
  clickable,
  onClick,
}) {
  const isActive = active && !completed;
  const isCompleted = completed;

  const circleBg =
    isCompleted || isActive
      ? themeColorsDesingSystem.primary.main
      : themeColorsDesingSystem.stone.medium;

  const circleColor =
    isCompleted || isActive
      ? themeColorsDesingSystem.text.secondary
      : themeColorsDesingSystem.text.primary;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      flex={1}
      minWidth={0}
      onClick={clickable ? onClick : undefined}
      sx={{
        cursor: clickable ? "pointer" : "default",
        opacity: clickable || active || completed ? 1 : 0.85,
      }}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: circleBg,
          color: circleColor,
          fontWeight: 700,
          fontSize: "1rem",
          transition: "background-color 0.2s ease",
        }}
      >
        {isCompleted ? (
          <CheckIcon sx={{ fontSize: 22, color: "#fff" }} />
        ) : (
          index + 1
        )}
      </Box>
      <Typography
        variant="caption"
        align="center"
        sx={{
          mt: 1,
          fontWeight: isActive || isCompleted ? 600 : 400,
          color:
            isActive || isCompleted
              ? themeColorsDesingSystem.primary.main
              : themeColorsDesingSystem.gray.dark,
          maxWidth: 120,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default function WizardStepper({
  currentStep = 0,
  maxCompletedStep = 0,
  onStepClick,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        width: "100%",
        maxWidth: 720,
        mx: "auto",
        py: 3,
        px: 2,
      }}
    >
      {STEPS.map((step, index) => {
        const completed = currentStep > step.key;
        const active = currentStep === step.key;
        const connectorDone = currentStep > step.key;
        const clickable =
          typeof onStepClick === "function" &&
          step.key !== currentStep &&
          step.key <= maxCompletedStep;

        return (
          <Box
            key={step.key}
            display="flex"
            alignItems="flex-start"
            flex={index < STEPS.length - 1 ? 1 : "0 0 auto"}
            minWidth={0}
          >
            <StepCircle
              index={step.key}
              label={step.label}
              active={active}
              completed={completed}
              clickable={clickable}
              onClick={() => onStepClick(step.key)}
            />
            {index < STEPS.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: 3,
                  mt: "18px",
                  mx: 1,
                  borderRadius: 2,
                  backgroundColor: connectorDone
                    ? themeColorsDesingSystem.primary.main
                    : themeColorsDesingSystem.stone.main,
                  transition: "background-color 0.2s ease",
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
